/**
 * Expose the Sentry SDK on the window object for use outside of Vue.
 */
import 'core-js';
import 'regenerator-runtime/runtime';
import init from './init';

init();
